import {
  Activity,
  Apple,
  BarChart3,
  CheckCircle2,
  Dumbbell,
  HeartPulse,
  MessagesSquare,
  ShieldCheck,
  Sparkles,
  Target,
  Trophy,
  Users,
  Video,
  Zap,
} from 'lucide-react';

export const siteConfig = {
  brand: 'MARTIN COACHING',
  shortBrand: 'MC',
  seoDescription:
    'Személyi edzés Székesfehérváron és online coaching személyre szabott edzéstervvel, étrenddel és folyamatos támogatással.',
  location: 'Székesfehérvár • Cutler Gym',
  launchLabel: 'Várható indulás: 2027 szeptember',
  contact: {
    phone: '+36 70 627 6614',
    phoneHref: '+36706276614',
    email: 'martinsomogyvari7@gmail.com',
    instagram: 'https://www.instagram.com/martinsomogyvari/',
    facebook: 'https://www.facebook.com/martin.somogyvari.7',
  },
};

export const navigation = [
  { label: 'Rólam', href: '#rolam' },
  { label: 'Szolgáltatások', href: '#szolgaltatasok' },
  { label: 'Eredmények', href: '#eredmenyek' },
  { label: 'Árak', href: '#arak' },
  { label: 'GYIK', href: '#gyik' },
  { label: 'Időpontfoglalás', href: '#idopontfoglalas' },
  { label: 'Kapcsolat', href: '#kapcsolat' },
];

export const stats = [
  {
    value: 100,
    suffix: '%',
    label: 'személyre szabott rendszer',
  },
  {
    value: 7,
    suffix: '/7',
    label: 'követhető támogatás',
  },
  {
    value: 60,
    suffix: ' perc',
    label: 'fókuszált személyi edzés',
  },
  {
    value: 1,
    suffix: ' cél',
    label: 'a te fejlődésed',
  },
];

export const valueCards = [
  {
    icon: Target,
    eyebrow: 'Nem sablon',
    title: 'A te célodra építve',
    text: 'A program az edzettségi szintedhez, időbeosztásodhoz, korábbi sérüléseidhez és valódi céljaidhoz igazodik.',
  },
  {
    icon: BarChart3,
    eyebrow: 'Mérhető haladás',
    title: 'Nem érzésre dolgozunk',
    text: 'Rendszeres mérés, edzésnapló, progresszió és visszajelzés alapján pontosan látod, hogy merre haladsz.',
  },
  {
    icon: ShieldCheck,
    eyebrow: 'Biztonságos alapok',
    title: 'Technika mindenekelőtt',
    text: 'Megtanulod helyesen kivitelezni a gyakorlatokat, hogy magabiztosan, hatékonyan és hosszú távon tudj fejlődni.',
  },
  {
    icon: MessagesSquare,
    eyebrow: 'Nem maradsz egyedül',
    title: 'Valódi támogatás',
    text: 'Nemcsak átadok egy tervet. Segítek az elakadásoknál, módosítok, és végig támogatlak a folyamatban.',
  },
];

export const services = [
  {
    icon: Dumbbell,
    label: 'Helyszíni',
    title: 'Személyi edzés',
    text: 'Egyéni edzés Székesfehérváron, teljes figyelemmel, pontos technikai javítással és folyamatos progresszióval.',
    features: [
      '60 perces alkalmak',
      'Állapot- és célfelmérés',
      'Személyre szabott terhelés',
    ],
    price: '8 990 Ft / alkalom',
    href: '#idopontfoglalas',
  },
  {
    icon: Video,
    label: 'Országosan',
    title: 'Online coaching',
    text: 'Komplett, követhető rendszer azoknak, akik önállóan edzenek, de szakmai iránymutatást és rendszeres kontrollt szeretnének.',
    features: [
      'Személyre szabott edzésterv',
      'Heti check-in',
      'Videós technikaelemzés',
    ],
    price: '24 990 Ft / hó',
    href: '#arak',
  },
  {
    icon: Activity,
    label: 'Egyszeri csomag',
    title: '6 hetes edzésterv',
    text: 'Átgondolt, progresszív edzésprogram gyakorlatleírásokkal, ismétléstartományokkal és fejlődési rendszerrel.',
    features: [
      'Edzőtermi vagy otthoni program',
      '6 hetes felépítés',
      'Egy módosítás benne van',
    ],
    price: '12 990 Ft',
    href: '#arak',
  },
  {
    icon: Apple,
    label: 'Egyszeri csomag',
    title: '6 hetes étrend + edzésterv',
    text: 'A célodhoz, preferenciáidhoz és napi rutinodhoz igazított edzés- és táplálkozási rendszer.',
    features: [
      'Kalória- és makrócélok',
      'Személyre szabott étrend',
      'Személyre szabott edzésterv',
    ],
    price: '12 990 Ft',
    href: '#arak',
  },
];

export const resultFilters = [
  'Összes',
  'Fogyás',
  'Izomépítés',
  'Életmódváltás',
];

export const results = [
  {
    category: 'Fogyás',
    name: 'Ádám',
    duration: '16 hét',
    outcome: '−12 kg, jobb állóképesség',
    quote:
      'Végre nemcsak lefogytam, hanem tudom is, hogyan tartsam meg az eredményt.',
    before:
      'https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=900&q=85',
    after:
      'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=900&q=85',
  },
  {
    category: 'Izomépítés',
    name: 'Dávid',
    duration: '24 hét',
    outcome: '+6 kg kontrollált tömegelés',
    quote:
      'Az edzéseim végre rendszerben vannak, és pontosan tudom, mikor min kell változtatni.',
    before:
      'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=900&q=85',
    after:
      'https://images.unsplash.com/photo-1577221084712-45b0445d2b00?auto=format&fit=crop&w=900&q=85',
  },
  {
    category: 'Életmódváltás',
    name: 'Viktória',
    duration: '12 hét',
    outcome: 'Rendszeres edzés, több energia',
    quote:
      'Nem egy szigorú diétát kaptam, hanem egy rendszert, amit a hétköznapokban is tudok tartani.',
    before:
      'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=900&q=85',
    after:
      'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&w=900&q=85',
  },
];

export const processSteps = [
  {
    number: '01',
    icon: MessagesSquare,
    title: 'Ingyenes 15 perces konzultáció',
    text: 'Röviden átbeszéljük a célodat, az edzésmúltadat, az időbeosztásodat és azt, hogy melyik szolgáltatás illik hozzád.',
  },
  {
    number: '02',
    icon: HeartPulse,
    title: 'Állapotfelmérés',
    text: 'Felmérjük a kiindulópontodat, a mozgásmintáidat és meghatározzuk a következő reális mérföldkövet.',
  },
  {
    number: '03',
    icon: Zap,
    title: 'Saját rendszered',
    text: 'Megkapod a személyre szabott edzéstervedet és szükség esetén a táplálkozási rendszeredet is.',
  },
  {
    number: '04',
    icon: Trophy,
    title: 'Fejlődés és finomhangolás',
    text: 'Mérjük az eredményeket, értékeljük a visszajelzéseidet és szükség szerint módosítjuk a tervet.',
  },
];

export const personalTrainingPlans = [
  {
    name: '1 alkalom',
    price: '8 990 Ft',
    unit: '/ alkalom',
    description:
      '60 perces személyi edzés teljes figyelemmel, helyes technikával és a céljaidhoz igazított terheléssel.',
    features: [
      '60 perces személyi edzés',
      'Állapot- és célfelmérés',
      'Folyamatos technikai javítás',
      'Személyre szabott terhelés',
    ],
    cta: 'Időpontot foglalok',
  },
  {
    name: '5 alkalmas bérlet',
    price: '42 500 Ft',
    unit: '8 500 Ft / alkalom',
    description:
      'Rugalmas csomag azoknak, akik rendszeresen szeretnének edzeni, de még nem választanának hosszabb bérletet.',
    features: [
      '5 × 60 perces személyi edzés',
      'Személyre szabott terhelés',
      'Technikai segítség minden alkalommal',
      'Folyamatos fejlődéskövetés',
    ],
    cta: 'Az 5 alkalmas bérletet választom',
  },
  {
    name: '10 alkalmas bérlet',
    price: '79 900 Ft',
    unit: '7 990 Ft / alkalom',
    description:
      'A legjobb ár-érték arány, ha következetesen és hosszabb távon szeretnél fejlődni.',
    features: [
      '10 × 60 perces személyi edzés',
      'Folyamatos fejlődéskövetés',
      'Technikai segítség minden alkalommal',
      'Személyre szabott fejlődési irány',
      'Alapító vendégprogram: az első 10 jelentkezőnek 74 900 Ft',
    ],
    cta: 'A 10 alkalmas bérletet választom',
    popular: true,
  },
  {
    name: 'Páros edzés',
    price: '13 990 Ft',
    unit: '/ alkalom összesen',
    description:
      '60 perces közös személyi edzés két fő részére, közös motivációval és egyéni figyelemmel.',
    features: [
      '60 perces páros edzés',
      'Két fő részére',
      'Mindkét résztvevőhöz igazított gyakorlatok',
      'Technikai segítség és folyamatos visszajelzés',
    ],
    cta: 'Páros edzést foglalok',
  },
  {
    name: '6 hetes életmódcsomag',
    price: '12 990 Ft',
    unit: '/ 6 hét',
    description:
      'Személyre szabott étrend és edzésterv azoknak, akik önállóan edzenének, de szakmai segítséget szeretnének.',
    features: [
      '6 hetes személyre szabott edzésterv',
      'Személyre szabott étrend',
      'Kalória- és makrójavaslat',
      'Gyakorlatok, sorozatok és ismétlések',
      '1 ingyenes módosítás',
    ],
    cta: 'Életmódcsomagot kérek',
  },
];

export const onlinePlans = [
  {
    name: 'Online coaching',
    price: '24 990 Ft',
    unit: '/ hónap',
    description:
      'Folyamatos online támogatás azoknak, akik önállóan edzenek, de szakmai kontrollt és rendszeres visszajelzést szeretnének.',
    features: [
      'Személyre szabott edzésterv',
      'Személyre szabott étrend',
      'Heti online check-in',
      'Edzésvideók elemzése',
      'Edzés- és étrendmódosítás',
      'Folyamatos online kapcsolattartás',
    ],
    cta: 'Online coachingot kérek',
    popular: true,
  },
];

export const testimonials = [
  {
    name: 'Bence',
    role: 'Online coaching kliens',
    text: 'Korábban mindig programról programra ugráltam. Itt először értettem meg, hogyan kell ténylegesen progresszálni, és miért változtatunk valamin.',
    rating: 5,
  },
  {
    name: 'Petra',
    role: 'Személyi edzés',
    text: 'Kezdőként féltem a konditeremtől, de már az első alkalom után sokkal magabiztosabb lettem. Minden gyakorlat érthetően van elmagyarázva.',
    rating: 5,
  },
  {
    name: 'Gergő',
    role: 'Életmódcsomag',
    text: 'Nem kellett mindent tökéletesen csinálnom. A rendszer a munkámhoz és az életemhez lett igazítva, ezért végre következetes tudtam maradni.',
    rating: 5,
  },
];

export const faqItems = [
  {
    question: 'Teljesen kezdőként is jelentkezhetek?',
    answer:
      'Igen. A kezdők sokszor különösen gyorsan fejlődnek, ha már az elején helyes technikát és átlátható rendszert kapnak. Az első alkalmak tempóját a jelenlegi állapotodhoz igazítjuk.',
  },
  {
    question: 'Hol lesznek a személyi edzések?',
    answer:
      'A tervek szerint Székesfehérváron, a Cutler Gymben. A személyes edzések várhatóan 2027 szeptemberében indulnak. A pontos indulási időpontot és a szabad idősávokat az oldalon, illetve a közösségi felületeken fogom közzétenni.',
  },
  {
    question: 'Kell külön kondibérletet vásárolnom?',
    answer:
      'Igen, a terem belépője vagy bérlete a személyi edzés díjától külön fizetendő.',
  },
  {
    question: 'Mennyi idő után látható eredmény?',
    answer:
      'Ez a kiindulási állapottól, a céltól, az edzésmúlttól és a következetességtől függ. Néhány hét után már érezhető lehet a fejlődés, de tartós és látványos változáshoz általában több hónapos következetes munka szükséges.',
  },
  {
    question: 'Az online coachinghoz kell edzőterem?',
    answer:
      'Nem feltétlenül. Készülhet otthoni vagy edzőtermi program is. A programot a rendelkezésedre álló eszközök alapján állítom össze.',
  },
  {
    question: 'Az étrend fix menü lesz?',
    answer:
      'Nem egy minden nap azonos, merev menüt kapsz. A cél egy fenntartható kalória- és makrókeret, mintaétrend és ételválasztási rendszer kialakítása.',
  },
  {
    question: 'Van ingyenes konzultáció?',
    answer:
      'Igen. Egy ingyenes, 15 perces konzultáció során röviden átbeszéljük a céljaidat, az edzésmúltadat és segítek kiválasztani a számodra megfelelő szolgáltatást.',
  },
  {
    question: 'Lemondható vagy áttehető egy személyi edzés?',
    answer:
      'Igen. Az időpont lemondása vagy módosítása legalább 24 órával az edzés kezdete előtt lehetséges. Ha nem tudsz megjelenni, kérlek időben jelezd, hogy másnak is lehetősége legyen foglalni.',
  },
];

export const trustItems = [
  {
    icon: CheckCircle2,
    text: 'Személyre szabott tervezés',
  },
  {
    icon: Users,
    text: 'Kezdőknek és haladóknak',
  },
  {
    icon: Sparkles,
    text: 'Prémium, követhető élmény',
  },
];